import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowNortheast24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13.586 9H8V7h9v9h-2v-5.586l-8.293 8.293-1.414-1.414z"
	})
});
const ForwardRef = forwardRef(SvgIconArrowNortheast24);
export default ForwardRef;
